import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';
import { TextField, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface Props {
    onClick: () => void,
    searchFilter: (filterString: string) => void,
}

export default ((props) => {
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            flexWrap="nowrap"
            bgcolor="background.paper"
            width="auto"
        >
            <Box p={2.5} mx={0.5}>
                <SearchIcon />
            </Box>
            <Box mx={0.5}>
                <TextField id="standard-search" label={t('search')} type="search" onChange={e => props.searchFilter(e.target.value)} />
            </Box>
            <Box p={1} mx={0.5}>
                <IconButton aria-label="add an alarm" onClick={props.onClick}>
                    <AddBoxIcon style={{ color: 'gray' }} />
                </IconButton>
            </Box>
        </Box>
    )
}) as React.FC<Props>
